/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IpsIcon extends BaseIcon {
  getChildren = () => [
    <title>posture-management</title>,
    <path fill="#aab4c4" d="M12.5,0,2,6.43V9H23V6.43ZM17,12v8h3V12ZM2,24H23V21H2Zm9-12v8h3V12ZM5,12v8H8V12Z"/>
  ]
  getViewBox = () => '0 0 24 24'
}
